import React from 'react';
import ReactDOM from 'react-dom/client';
import { ArcElement, Chart } from 'chart.js';

import type { Candu } from '@/types/candu.d.ts';

import './i18n.ts';

import App from './root/App.tsx';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

Chart.register(ArcElement);

const enableMocking = async () => {
  if (process.env.VITE_DISABLE_MOCKS) {
    return;
  }

  const { worker } = await import('@/mocks/browser.ts');

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start();
};

enableMocking()
  .then(() => loadCanduScript(import.meta.env.VITE_CANDU_CLIENT_TOKEN))
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });

export const loadCanduScript = (clientToken: string = ''): Promise<Candu | undefined> =>
  new Promise(resolve => {
    if (!clientToken) {
      resolve(undefined);

      return;
    }

    const script = document.createElement('script');
    script.setAttribute('src', 'https://cdn.candu.ai/sdk/latest/candu.umd.js?token=' + clientToken);
    script.onload = () => resolve(window.Candu);
    script.onerror = () => {
      resolve(undefined);
    };

    document.head.appendChild(script);
  });
